import { render, staticRenderFns } from "./NewTweet.vue?vue&type=template&id=15167f7a&scoped=true&"
import script from "./NewTweet.vue?vue&type=script&lang=js&"
export * from "./NewTweet.vue?vue&type=script&lang=js&"
import style0 from "./NewTweet.vue?vue&type=style&index=0&id=15167f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15167f7a",
  null
  
)

export default component.exports